module.exports = __webpack_public_path__ + "img/MD_1140x255px-desktop.47239a0.webp";